import { showToast } from "./toast";
import { TOAST_TYPE, TOAST_MESSAGE_KEY } from "../../constants/toast";
import { curry } from "lodash";

export const METHOD = {
  get: "get",
  post: "post",
};

export const getMessageByStatusCode = (status) => {
  switch (status) {
    case 400: {
      return TOAST_MESSAGE_KEY.badRequest;
    }

    case 401:
    case 403: {
      return TOAST_MESSAGE_KEY.unauthorized;
    }

    case 500: {
      return TOAST_MESSAGE_KEY.serverError;
    }

    default: {
      return TOAST_MESSAGE_KEY.unexpected;
    }
  }
};

export const getNetworkMessage = (method) => {
  switch (method) {
    case METHOD.get: {
      return TOAST_MESSAGE_KEY.failRetrieve;
    }

    case METHOD.post: {
      return TOAST_MESSAGE_KEY.failSend;
    }

    default: {
      return TOAST_MESSAGE_KEY.unexpected;
    }
  }
};

export const errorHandler = curry((name, dispatch, error) => {
  let errorMessage = "";

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    errorMessage = getMessageByStatusCode(error.response.status);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js

    errorMessage = getNetworkMessage(error.config.method);
  } else {
    // Something happened in setting up the request that triggered an Error

    errorMessage = error.message;
  }

  if (window?.DD_RUM) {
    window.DD_RUM.addError(error, {
      scope: "platform-continuing-education",
      team: "cd.levant",
    });
  }
  showToast(dispatch, errorMessage, TOAST_TYPE.error, { name });
});
